import React from 'react';
import { Button } from '../../components/ui/button';
import { History } from 'lucide-react';
import { useLocation, useNavigate } from 'react-router-dom';
import NavBar from './NavBar';
import ExtractionTitle from './ExtractionTitle';
import ExtSectionHeader from './ExtSectionHeader';
import { useExtractionContext } from '../../contexts/extractions/ExtractionContext';
import RightButton from './RightButton';
import IngestionTopLoader from '../../components/IngestionTopLoader';
import { useSelector } from 'react-redux';

const ExtractionLayout = ({ children, hideRightButton = false }) => {
  const navigate = useNavigate();
  const {
    stepVal,
    currentSubStep,
    handleNavigateToStep,
    getContentDescription,
  } = useExtractionContext();

  const contentDescription = getContentDescription();
  const isViewMode = useLocation().pathname.includes('/extraction/view');
  const isViewFullData = useLocation().pathname.includes('/view-full-data');

  const ingestion = useSelector((state) => state.Extractions.ingestion) || {};
  const percentage = typeof ingestion.progress === 'number' ? ingestion.progress : 0;
  const actionInProgress = typeof ingestion.action === 'string'
    ? ingestion.action.toLowerCase()
    : '';
  const isIngestingAction =
    actionInProgress === 'ingesting' ||
    actionInProgress === 'in_progress' ||
    actionInProgress === 'processing' ||
    actionInProgress === 'running';
  const isIngesting = (percentage > 0 && percentage < 100) || (isIngestingAction && percentage < 100);

  return (
    <div className="min-h-screen bg-slate-50">
      {/* Header */}
      <div className="bg-white border-b shadow-sm">
        <div className="px-6 py-4">
          <div className="flex items-center justify-between">
            <ExtractionTitle />
            <Button
              variant="border_outline"
              onClick={() => navigate('/extraction/history')}
            >
              <History className="h-4 w-4 mr-2" />
              Show History
            </Button>
          </div>
        </div>
      </div>

      {/* Progress Steps */}
      <div className="bg-white border-b">
        <div className="px-6 py-4">
          <NavBar
            currentStep={stepVal}
            currentSubStep={currentSubStep}
            navigeteToStep={handleNavigateToStep}
          />
        </div>
      </div>

      {/* Section Header */}
      <ExtSectionHeader stepVal={stepVal} />

      {/* Top loader sits here — full width, no padding applied yet */}
      <div className="relative">
        {isIngesting && isViewFullData && <IngestionTopLoader percentage={percentage} />}
        
        {/* Main Content */}
        <div className="px-6 py-4">
          <div className={`${stepVal === 1 ? 'max-w-4xl' : ''} mx-auto`}>
            <div className="flex justify-between items-center">
              {contentDescription && (
                  <p className="text-slate-600 mb-4">{contentDescription}</p>
              )}
              {/* Only show RightButton if not explicitly hidden and not in view mode */}
              {!hideRightButton && !isViewMode && <div className="mb-2">
                <RightButton stepVal={stepVal} />
              </div>}
            </div>
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExtractionLayout;